import React, { useContext, useEffect, useRef, useState } from 'react'
import Context from '../../context'
import {
  checkEmail,
  createUser,
  getPartnersList,
  getUsersGroupList,
  getWhiteLabelList
} from '../../services/ClubeApi'
import ProgressBar from '../ProgressBar'

function UserCreateModal() {
  const closeButton = useRef(null)
  const { setOpenToast, objectData, setObjectData, partnerStr, setPartnerStr } = useContext(Context)
  const [groupList, setGroupList] = useState([])
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [whiteLabelList, setWhiteLabelList] = useState([])
  const [partnerList, setPartnerList] = useState([])
  const [fullPartnerList, setFullPartnerList] = useState([])
  const [unitiesList, setUnitiesList] = useState([])

  const [showInput, setShowInput] = useState({
    partner: false,
    unit: false,
    enterprise: false
  })

  useEffect(() => {
    getUsersGroupList().then(r => {
      if (r) {
        setGroupList(r)
      } else {
        setOpenToast({
          open: true,
          message: 'Ocorreu algum erro ao buscar a lista de usuários',
          type: 'error'
        })
      }
    })

    getWhiteLabelList().then(r => {
      console.log('whiteLabel', r)
      setWhiteLabelList(r)
    })

    getPartnersList().then(r => {
      setFullPartnerList(r)
    })
  }, [])

  useEffect(() => {
    if (fullPartnerList.length > 0 && whiteLabelList.length > 0) setIsLoading(false)
  }, [whiteLabelList, fullPartnerList])

  const handleSearchInput = value => {
    if (value.length > 0) {
      setPartnerList(
        fullPartnerList.filter(item => {
          return item.fantasyName.toLowerCase().includes(value.toLowerCase())
        })
      )
    } else {
      setPartnerList([])
    }
    setPartnerStr(value)
  }

  const checkAvailableEmail = email => {
    if (email.length > 0 && !objectData.id) {
      checkEmail(email).then(r => {
        if (!r) {
          setInvalidEmail(true)
          setOpenToast({
            open: true,
            message: 'E-mail já cadastrado em nosso sistema, favor inserir outro.',
            type: 'error'
          })
        } else {
          setInvalidEmail(false)
        }
      })
    }
  }

  const handleSendButton = async () => {
    setIsLoading(true)
    const createdUser = createUser(objectData)

    if (createdUser) {
      setOpenToast({
        open: true,
        message: 'Usuário criado com sucesso.',
        type: 'success'
      })
      setIsLoading(false)
      setObjectData({
        name: '',
        password: '',
        office: '',
        userGroup: ''
      })
      closeButton.current.click()
    } else {
      setOpenToast({
        open: true,
        message:
          'Ocorreu algum erro ao criar o usuário, favor verifique todos os campos e tente novamente',
        type: 'error'
      })
      setIsLoading(false)
    }
  }

  const handleCancelButton = () => {
    setObjectData({
      name: '',
      password: '',
      office: '',
      userGroup: ''
    })
  }

  const handlePartnerSelect = partnerId => {
    setObjectData({ ...objectData, partnerId })
    setPartnerList([])

    const partner = fullPartnerList.find(item => item.id === partnerId)

    setPartnerStr(partner.fantasyName)
    const { PartnerUnits } = partner

    setUnitiesList(PartnerUnits)
  }

  useEffect(() => {
    console.log('userGroup', objectData.userGroup)
    // Verificar se é de empresa (Whitelabel)
    if (objectData.userGroup === '6' || objectData.userGroup === '7') {
      setShowInput({ partner: false, unit: false, enterprise: true })
    }
    // Verificar se é de Unidade
    else if (objectData.userGroup === '2') {
      setShowInput({ partner: true, unit: true, enterprise: false })
    }
    // Verificar se é de Parceiro
    else if (objectData.userGroup === '4') {
      setShowInput({ partner: true, unit: false, enterprise: false })
    } else {
      setShowInput({ partner: false, unit: false, enterprise: false })
    }
  }, [objectData.userGroup])

  useEffect(() => {
    console.log('objectData', objectData)

    if (objectData.id && objectData.Partner) {
      const partner = fullPartnerList.find(item => item.id === objectData.Partner.id)
      if (partner) {
        const { PartnerUnits } = partner

        setUnitiesList(PartnerUnits)
      }
    }
  }, [objectData])

  return (
    <div
      className="modal fade"
      id="userCreateModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="userCreateModalLabel"
      aria-hidden="true"
      style={{ zIndex: 9999 }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="userCreateModalLabel">
              Adicionar Usuário
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {isLoading ? (
              <ProgressBar height="20px" />
            ) : (
              <form
                onSubmit={e => {
                  e.preventDefault()
                }}
              >
                <div className="form-group">
                  <label htmlFor="name">Nome</label>
                  <input
                    value={objectData.name || ''}
                    onChange={e => setObjectData({ ...objectData, name: e.target.value })}
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Nome Completo"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-mail</label>
                  <input
                    value={objectData.email || ''}
                    onChange={e => setObjectData({ ...objectData, email: e.target.value })}
                    type="email"
                    id="email"
                    className={`form-control ${invalidEmail && 'clube-border-danger'}`}
                    placeholder="name@example.com"
                    onBlur={e => checkAvailableEmail(e.target.value)}
                    autoComplete="new-email"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Senha</label>
                  <input
                    value={objectData.password || ''}
                    onChange={e => setObjectData({ ...objectData, password: e.target.value })}
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="senha"
                    autoComplete="new-password"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="office">Cargo</label>
                  <input
                    value={objectData.office || ''}
                    onChange={e => setObjectData({ ...objectData, office: e.target.value })}
                    type="text"
                    id="office"
                    className="form-control"
                    placeholder="Vendedor Externo"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="userGroup">Grupo de Permissões</label>
                  <select
                    value={objectData.userGroup || ''}
                    onChange={e =>
                      setObjectData({
                        ...objectData,
                        userGroup: e.target.value
                      })
                    }
                    className="form-control"
                    id="userGroup"
                  >
                    <option>Selecione</option>
                    {groupList.map(item => (
                      <option key={item.id} value={`${item.id}`}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                {!!showInput.enterprise && (
                  <div className="form-group">
                    <label htmlFor="whiteLabel">Empresa</label>
                    <select
                      value={objectData.whiteLabelId || ''}
                      onChange={e =>
                        setObjectData({
                          ...objectData,
                          whiteLabelId: e.target.value
                        })
                      }
                      className="form-control"
                      id="whiteLabel"
                    >
                      <option>Selecione</option>
                      {whiteLabelList.map(item => (
                        <option key={item.id} value={`${item.id}`}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {!!showInput.partner && (
                  <>
                    <div className="form-group">
                      <label htmlFor="partner">Parceiro</label>
                      <input
                        value={partnerStr}
                        onChange={e => handleSearchInput(e.target.value)}
                        type="partner"
                        id="partner"
                        className="form-control"
                        placeholder="Buscar Parceiro"
                      />
                    </div>

                    <div className="form-group">
                      {partnerList.map(item => (
                        <li
                          className="item-click"
                          key={item.id}
                          style={{ marginBottom: '10px' }}
                          onClick={() => handlePartnerSelect(item.id)}
                          role="presentation"
                        >
                          {item.fantasyName}
                        </li>
                      ))}
                    </div>
                  </>
                )}

                {!!showInput.unit && !!objectData.partnerId && (
                  <div className="form-group">
                    <label htmlFor="partnerUnitId">Unidade</label>
                    <select
                      value={objectData.partnerUnitId || ''}
                      onChange={e =>
                        setObjectData({
                          ...objectData,
                          partnerUnitId: e.target.value
                        })
                      }
                      className="form-control"
                      id="partnerUnitId"
                    >
                      <option>Selecione</option>
                      {unitiesList.map(item => (
                        <option key={item.id} value={item.id}>
                          {item.fantasyName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </form>
            )}
          </div>
          <div className="modal-footer">
            <button
              ref={closeButton}
              onClick={handleCancelButton}
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              disabled={invalidEmail}
              type="button"
              className="btn btn-primary"
              onClick={handleSendButton}
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserCreateModal
